export default {
    props: {
        editableConfirmation: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'editable.confirmation'
        }, 
        editableCreate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.create'
        }, 
        editableDestroy: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.destroy'
        }, 
        editableEditRecurringMode: {
            type: String,
            default: undefined,
            kComposite: 'editable.editRecurringMode'
        }, 
        editableMove: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.move'
        }, 
        editableResize: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.resize'
        }, 
        editableTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.template'
        }, 
        editableUpdate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.update'
        }, 
        editableWindow: {
            type: Object,
            default: undefined,
            kComposite: 'editable.window'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoScheduler/Editable.js